<div class="modal active">
    <div class="modal__container">
        <div class="fields">
            <h2>Airspace Vertex Import Options</h2>
            <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
              <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
                <div class="fields__block">
                  <div class="fields__block__section">
                    <div class="table-fields">
                      <h4> Configured imported Coordinate Points </h4>
                      <div style="height: 240px; overflow-y:auto;">
                          <table>
                              <thead>
                                <tr>
                                  <th>Identifier</th>
                                  <th>Name</th>
                                  <th>Latitude</th>
                                  <th>Longitude</th>
                                  <th>Max Altitude</th>
                                  <th>Min Altitude</th>
                                  <th>Status</th>
                                </tr>
                              </thead>
                                <tbody>
                                  <tr *ngFor="let cp of coordPoints; let i = index">
                                    <td> <input type="text" id="coordpointid_{{i}}" (blur)="checkIfvalid(cp)" [(ngModel)]="cp.coordpointid"></td>
                                    <td>{{cp.name}}</td>
                                    <td>{{cp.latitude}}</td>
                                    <td>{{cp.longitude}}</td>
                                    <td>{{cp.maxaltitude}}</td>
                                    <td>{{cp.minaltitude}}</td>

                                    <td *ngIf="!cp.isDuplicate && !cp.invalidId" bgcolor="#02f54f">OK</td>
                                    <td *ngIf="cp.invalidId" bgcolor="#00FFFF">Id length cannot exceed 5 characters</td>
                                    <td *ngIf="cp.isDuplicate && !cp.invalidId" bgcolor="#00FFFF">Duplicated identifier</td>
                                  </tr>
                              </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="fields__btn">
                  <button (click)="proceedWithImport()" class="blue">Ok</button>
  
                  <button (click)="cancel();" class="blue" >Cancel</button>
                </div>
              </div>
        </div>
      </div>
  </div>
